module.exports = __webpack_public_path__ + "media/images/dailySpecialMarker@3x-e41646e77be2adca86e2832400ca66d0.png";